module.exports = __webpack_public_path__ + "img/68.0e7730de.png";